import http from 'services/http'

export const getCredentials = currentAuthApi => {
  return http.get(`/${currentAuthApi}/credentials/fresh-chat`)
}

export default {
  getCredentials
}
